<template>
  <div class="iframe-container">
    <iframe ref="iframe" :src="url" frameborder="0" @load="adjustIframeHeight"></iframe>
  </div>
</template>

<script>
export default {
  name: "GoogleFormIframe",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    adjustIframeHeight() {
      const iframe = this.$refs.iframe;
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
    }
  }
};
</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 4900px;
  z-index: 9999;
  background-color: white;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

</style>
